import { loadRoutes } from '@clearscore/helpers.cache';
import { lookupById } from '@clearscore/helpers.state-normalise';
import requestStatuses from '@clearscore/constants.request-statuses';
import { types as sessionTypes } from '@clearscore/redux.session';

import { ROUTES_REINITIALISE } from '../types';
import filterRoutesByStatus from './lib/filterRoutesByStatus';

/**
 * Normalise routes by status
 * @param routes
 * @return {{byId, allIds: Array}}
 */
function normaliseStatus(routes) {
    const byId = lookupById(routes, 'idvStatus', 'routes');
    const allIds = Object.keys(byId);

    return {
        status: requestStatuses.INITIAL,
        byId,
        allIds,
    };
}

/**
 * Route initial state
 * @returns {array}
 */
const initialState = normaliseStatus(loadRoutes());

/**
 * Routes Reducer
 * @param state
 * @param action
 */
export default function routesReducer(state = initialState, action = {}) {
    switch (action.type) {
        case sessionTypes.TIMEOUT_SUCCESS:
        case sessionTypes.LOGOUT_SUBMIT:
        case ROUTES_REINITIALISE:
            if (action && action.payload && action.payload.routes) {
                const { routes, accountIDVStatus } = action.payload;

                return {
                    ...normaliseStatus([...loadRoutes(), ...filterRoutesByStatus(routes, accountIDVStatus)]),
                    status: requestStatuses.SUCCESS,
                };
            }
            return {
                ...state,
                status: requestStatuses.SUCCESS,
            };
        default:
            return state;
    }
}
